export enum TERMS_OF_USE_DATA{
  PATH='/terms-of-use',
  TITLE='Terms of use',
  TEMPLATE='PID-22 Terms of use'
 }